// eslint-disable-next-line import/no-unassigned-import
import 'reflect-metadata';
import { environment } from '../../environments/environment';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions,@typescript-eslint/naming-convention
export function Mockable<T extends new(...args: any[]) => unknown>(target: T) {
    if (environment.production) {
        return target;
    }

    const mockables = [];
    const propertyNames = Object.getOwnPropertyNames(target.prototype).filter(name => name !== 'constructor');
    for (const prop of propertyNames) {
        const descriptor = Object.getOwnPropertyDescriptor(target.prototype, prop);
        if (!(descriptor.value instanceof Function)) {
            continue;
        }

        mockables.push(prop);
    }

    // eslint-disable-next-line no-underscore-dangle
    target.prototype.__mockables = mockables;

    return target;
}
